// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import {useEffect, useRef} from 'react';

export const use_previous = <T>(value: T): T | null=>{
    const ref = useRef<T | null>(null);
    useEffect(()=>void (ref.current = value), [value]);
    return ref.current;
};
